import React, { Component } from "react";
import { Drawer, Tag, Descriptions, Input, Popconfirm, Space, Alert } from "antd";
import { PlayCircleOutlined, CalendarOutlined, StopOutlined, UndoOutlined, DeleteOutlined, FileTextOutlined, CheckOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import { estatusPlan, formatoFecha } from "../cmmsComun";
import ModalCalendarizarCMMS from "./ModalCalendarizarCMMS";
import ModalNoRealizadoCMMS from "./ModalNoRealizadoCMMS";
import { calendarizarPlanes, noRealizarPlanes, reactivarPlanes, editarPlan, eliminarPlan } from "./accionesPlanes";

// Detalle de un servicio calendarizado (renglon del programa) con sus acciones.
// plan: renglon como lo arma el backend (armarPlanes). onCambio() recarga la pantalla.
class DrawerPlanCMMS extends Component {
    state = { calendarizar: false, noRealizado: false, folio: "", notas: "", editandoFolio: false };

    componentDidUpdate(prev) {
        if (this.props.plan && this.props.plan !== prev.plan) this.setState({ folio: this.props.plan.folioExterno || "", notas: this.props.plan.notas || "", editandoFolio: false });
    }

    terminar = (ok) => {
        if (!ok) return;
        this.setState({ calendarizar: false, noRealizado: false });
        this.props.onCambio?.();
    };

    guardarTexto = async (campo, valor) => {
        if (await editarPlan(this.props, this.props.plan._id, { [campo]: valor })) this.props.onCambio?.(true);
    };

    render() {
        const p = this.props.plan;
        if (!p) return null;
        const est = estatusPlan(p.estatusVisible);
        // Contrato cancelado: solo se consulta (y se puede abrir su servicio, si tiene).
        const bloqueado = !!this.props.bloqueado || !!p.contratoCancelado;
        const pendiente = p.estatus === 1 && !p.servicioId && !bloqueado;
        // Sin el permiso "Mover en la agenda" lo que ya tiene fecha no se mueve (si se le cambia el ingeniero).
        const fechaFija = this.props.puedeMover === false && !!p.fechaPlaneada;
        return (
            <Drawer
                visible={this.props.visible}
                onClose={this.props.onClose}
                width={window.innerWidth > 640 ? 480 : "100%"}
                title={
                    <div>
                        <div style={{ fontWeight: 600 }}>{p.activoTexto}</div>
                        <div style={{ fontSize: 12, color: "#7a8794", fontWeight: 400 }}>
                            {[p.clienteNombre, p.sucursalNombre].filter(Boolean).join(" · ")}
                        </div>
                    </div>
                }
                footer={
                    <Space wrap>
                        {pendiente && (
                            <ButtonItem type="primary" icon={<PlayCircleOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { planId: p._id })}>
                                Iniciar servicio
                            </ButtonItem>
                        )}
                        {p.servicioId && (
                            <ButtonItem type="primary" icon={<FileTextOutlined />} onClick={() => this.props.history.push("/panel/cmmsServicio", { id: p.servicioId })}>
                                Abrir {p.servicioCodigo || "servicio"}
                            </ButtonItem>
                        )}
                        {(pendiente || (p.estatus === 3 && !bloqueado)) && (
                            <ButtonItem type="default" icon={<CalendarOutlined />} onClick={() => this.setState({ calendarizar: true })}>
                                {fechaFija ? "Cambiar ingeniero" : p.fechaPlaneada ? "Reprogramar" : "Calendarizar"}
                            </ButtonItem>
                        )}
                        {pendiente && (
                            <ButtonItem type="default" rojo icon={<StopOutlined />} onClick={() => this.setState({ noRealizado: true })}>
                                No realizado
                            </ButtonItem>
                        )}
                        {p.estatus === 3 && !bloqueado && (
                            <ButtonItem type="default" icon={<UndoOutlined />} onClick={async () => this.terminar(await reactivarPlanes(this.props, [p._id]))}>
                                Reactivar
                            </ButtonItem>
                        )}
                        {pendiente && !p.contratoId && (
                            <Popconfirm title="¿Quitar de la agenda?" okText="Sí" cancelText="No" onConfirm={async () => (await eliminarPlan(this.props, p._id)) && this.props.onCambio?.()}>
                                <ButtonItem type="default" icon={<DeleteOutlined />}>
                                    Quitar
                                </ButtonItem>
                            </Popconfirm>
                        )}
                    </Space>
                }
            >
                <Tag color={est.color} style={{ marginBottom: 10 }}>
                    {est.label}
                </Tag>
                {p.contratoCancelado ? <Tag color="red">Contrato cancelado</Tag> : null}
                {p.estatus === 3 && p.motivoNoRealizado ? <Alert type="error" showIcon style={{ marginBottom: 10 }} message={`Motivo: ${p.motivoNoRealizado}`} /> : null}
                <Descriptions column={1} size="small" bordered labelStyle={{ width: 140 }}>
                    <Descriptions.Item label="Tipo de servicio">{p.tipoServicioNombre}</Descriptions.Item>
                    <Descriptions.Item label="Fecha">{p.fechaPlaneada ? formatoFecha(p.fechaPlaneada) : "Sin fecha"}</Descriptions.Item>
                    <Descriptions.Item label="Ingeniero">
                        {p.empleadoNombre
                            ? `${p.empleadoNombre}${!p.fechaPlaneada && p.estatus === 1 && !p.servicioId ? " (sugerido)" : ""}`
                            : p.estatus === 1 && !p.servicioId
                            ? "Para todos (sin asignar)"
                            : "Sin asignar"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Contrato">{p.contratoNombre ? `${p.contratoNombre}${p.vueltaNombre ? ` · ${p.vueltaNombre}` : ""}` : "Sin contrato (agenda)"}</Descriptions.Item>
                    <Descriptions.Item label="Ubicación">{[p.activo?.ubicacion, p.activo?.area].filter(Boolean).join(" · ") || "—"}</Descriptions.Item>
                    <Descriptions.Item label="Folio externo">
                        {this.state.editandoFolio && !bloqueado ? (
                            <Input.Search
                                size="small"
                                autoFocus
                                maxLength={60}
                                enterButton={<CheckOutlined />}
                                value={this.state.folio}
                                onChange={(e) => this.setState({ folio: e.target.value })}
                                onSearch={(v) => this.setState({ editandoFolio: false }, () => this.guardarTexto("folioExterno", v))}
                            />
                        ) : (
                            <span style={{ cursor: "pointer" }} onClick={() => this.setState({ editandoFolio: true })}>
                                {p.folioExterno || <span style={{ color: "#9aa7b4" }}>Agregar (ej. SER10000118022)</span>}
                            </span>
                        )}
                    </Descriptions.Item>
                    {p.servicioCodigo ? (
                        <Descriptions.Item label="Orden de Servicio">
                            {p.servicioCodigo} · {p.servicioEstatusNombre}
                        </Descriptions.Item>
                    ) : null}
                </Descriptions>
                <div className="cmms-etiqueta-campo" style={{ marginTop: 12 }}>
                    Notas
                </div>
                <Input.TextArea
                    rows={3}
                    maxLength={1000}
                    disabled={bloqueado}
                    value={this.state.notas}
                    onChange={(e) => this.setState({ notas: e.target.value })}
                    onBlur={() => this.state.notas !== (p.notas || "") && this.guardarTexto("notas", this.state.notas)}
                    placeholder="Ej. llevar batería de repuesto"
                />

                <ModalCalendarizarCMMS
                    {...this.props}
                    visible={this.state.calendarizar}
                    titulo={fechaFija ? "Cambiar ingeniero" : p.fechaPlaneada ? "Reprogramar" : "Calendarizar"}
                    cantidad={1}
                    fechaInicial={p.fechaPlaneada}
                    empleadoInicial={p.empleadoId}
                    fechaBloqueada={fechaFija}
                    permitirQuitarFecha={!!p.fechaPlaneada && !!p.contratoId}
                    onCancel={() => this.setState({ calendarizar: false })}
                    onAceptar={async (datos) => this.terminar(await calendarizarPlanes(this.props, [p._id], datos))}
                />
                <ModalNoRealizadoCMMS
                    visible={this.state.noRealizado}
                    cantidad={1}
                    motivos={this.props.motivos}
                    onCancel={() => this.setState({ noRealizado: false })}
                    onAceptar={async (motivo) => this.terminar(await noRealizarPlanes(this.props, [p._id], motivo))}
                />
            </Drawer>
        );
    }
}

export default DrawerPlanCMMS;
